import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useAppStore } from '../../store';
import { Ic } from '../icons';
import { attachmentObjectUrl, conversationAvatarObjectUrl, useMessenger } from '../messenger/store';
import { useFedStore } from '../store';

const REACTIONS = ['👍', '❤️', '🔥', '😂', '👏', '👎'];
const CHAT_KZ = {
  'Закрыть':'Жабу','НОВОЕ ОБЩЕНИЕ':'ЖАҢА ӘҢГІМЕ','Создать чат':'Чат құру','Личное сообщение':'Жеке хабарлама','Группа':'Топ','Название группы':'Топ атауы','Например, Команда на CS2 OPEN':'Мысалы, CS2 OPEN командасы','Найти человека по нику':'Пайдаланушы аты бойынша іздеу','Участник платформы':'Платформа қатысушысы','заблокирован':'бұғатталған','Пользователи не найдены':'Пайдаланушылар табылмады','Выбрано':'Таңдалды','Создать группу':'Топ құру','БЕЗОПАСНОСТЬ':'ҚАУІПСІЗДІК','Отправить жалобу':'Шағым жіберу','Причина':'Себебі','Опишите нарушение':'Ереженің бұзылуын сипаттаңыз','Отправить':'Жіберу','ПЕРЕСЫЛКА':'ҚАЙТА ЖІБЕРУ','Выберите чат':'Чатты таңдаңыз','Личный диалог':'Жеке чат','ЛИЧНЫЙ ДИАЛОГ':'ЖЕКЕ ЧАТ','УПРАВЛЕНИЕ ГРУППОЙ':'ТОПТЫ БАСҚАРУ','Изменить аватар группы':'Топ аватарын өзгерту','Вы владелец':'Сіз иесіз','Вы администратор':'Сіз әкімшісіз','Вы участник':'Сіз қатысушысыз','Удалить фото':'Фотоны жою','Открепить':'Бекітуден алу','Закрепить':'Бекіту','Включить push':'Хабарландыруды қосу','Отключить push':'Хабарландыруды өшіру','Разблокировать':'Бұғаттан шығару','Сообщения недоступны':'Хабарламалар қолжетімсіз','Заблокировать':'Бұғаттау','Пожаловаться':'Шағымдану','Сохранить':'Сақтау','Участники':'Қатысушылар','Владелец':'Иесі','Админ':'Әкімші','Участник':'Қатысушы','Добавить участника':'Қатысушы қосу','Покинуть группу':'Топтан шығу','Фотография':'Фото','Убрать фотографию':'Фотоны алып тастау','Системное сообщение':'Жүйелік хабарлама','Переслано от':'Қайта жіберген','не отправлено':'жіберілмеді','изм.':'өзг.','Ответить':'Жауап беру','Реакция':'Реакция','Переслать':'Қайта жіберу','Редактировать':'Өңдеу','Удалить':'Жою','Удалить сообщение?':'Хабарламаны жою керек пе?','ВНУТРИ ПЛАТФОРМЫ':'ПЛАТФОРМА ІШІНДЕ','Сообщения':'Хабарламалар','Поиск по чатам':'Чаттардан іздеу','Все':'Барлығы','Непрочитанные':'Оқылмаған','Группы':'Топтар','Пользователи':'Пайдаланушылар','по имени и username':'аты және username бойынша','Чаты':'Чаттар','Закреплённый чат':'Бекітілген чат','Вы':'Сіз','Сообщение удалено':'Хабарлама жойылды','Начните новый диалог':'Жаңа диалог бастаңыз','Ничего не найдено':'Ештеңе табылмады','Диалогов пока нет':'Әзірге диалог жоқ','Проверьте имя или username пользователя':'Пайдаланушының аты немесе username-ын тексеріңіз','Создайте личный чат или группу':'Жеке чат немесе топ құрыңыз','Загрузка диалогов':'Диалогтар жүктелуде','Выберите диалог':'Диалогты таңдаңыз','Продолжите общение с игроками или создайте новую группу.':'Ойыншылармен сөйлесуді жалғастырыңыз немесе жаңа топ құрыңыз.','Загрузить предыдущие сообщения':'Алдыңғы хабарламаларды жүктеу','Редактирование':'Өңдеу','Ответ':'Жауап','Прикрепить фотографии':'Фотоларды тіркеу','Разблокируйте пользователя для отправки':'Жіберу үшін пайдаланушыны бұғаттан шығарыңыз','Написать сообщение…':'Хабарлама жазу…','Отправить сообщение':'Хабарлама жіберу','ОБЩЕНИЕ ВНУТРИ ПЛАТФОРМЫ':'ПЛАТФОРМА ІШІНДЕГІ БАЙЛАНЫС','Войдите, чтобы открыть сообщения':'Хабарламаларды ашу үшін кіріңіз','Личные диалоги и командные группы доступны участникам платформы.':'Жеке чаттар мен командалық топтар платформа қатысушыларына қолжетімді.','Войти в аккаунт':'Аккаунтқа кіру','Назад к диалогам':'Диалогтарға оралу','Участники и управление чатом':'Қатысушылар және чатты басқару','Открыть информацию и управление чатом':'Чат ақпараты мен басқаруын ашу','личный диалог':'жеке чат','обмен сообщениями заблокирован':'хабар алмасу бұғатталған','участника':'қатысушы','Сообщение':'Хабарлама','Сегодня':'Бүгін','Вчера':'Кеше','Матч':'Матч',
  'Сделать участником':'Қатысушы ету','Сделать администратором':'Әкімші ету','Передать права владельца':'Иелік құқығын беру','Исключить':'Шығару','Исключить участника':'Қатысушыны шығару','Фотография из сообщения':'Хабарламадағы фото'
};
const useChatT = () => { const kz = useFedStore((state) => state.lang === 'kz'); return (text) => kz ? (CHAT_KZ[text] || text) : text; };
const time = (stamp) => new Date(stamp).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
const day = (stamp, kz = false) => {
  const date = new Date(stamp), today = new Date();
  if (date.toDateString() === today.toDateString()) return kz ? 'Бүгін' : 'Сегодня';
  const yesterday = new Date(today); yesterday.setDate(today.getDate() - 1);
  if (date.toDateString() === yesterday.toDateString()) return kz ? 'Кеше' : 'Вчера';
  return date.toLocaleDateString(kz ? 'kk-KZ' : 'ru-RU', { day: 'numeric', month: 'long' });
};

function useModalClose(onClose) {
  useEffect(() => {
    const old = document.body.style.overflow;
    const key = (event) => event.key === 'Escape' && onClose();
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', key);
    return () => { document.body.style.overflow = old; window.removeEventListener('keydown', key); };
  }, [onClose]);
}

function Avatar({ chat, size = 46 }) {
  const [src, setSrc] = useState('');
  const avatarUrl = chat?.avatar?.url, avatarVersion = chat?.avatar?.version, chatId = chat?.id;
  useEffect(() => {
    let alive = true;
    setSrc('');
    if (avatarUrl) conversationAvatarObjectUrl({ id: chatId, avatar: { url: avatarUrl, version: avatarVersion } }).then((url) => alive && setSrc(url)).catch(() => {});
    return () => { alive = false; };
  }, [chatId, avatarUrl, avatarVersion]);
  return (
    <span className="msg-avatar" style={{ '--msg-accent': chat.accent, width: size, height: size, fontSize: size < 42 ? 10 : 12 }}>
      {src ? <img src={src} alt="" /> : <b>{chat.initials}</b>}
    </span>
  );
}

function Modal({ children, onClose, className = '', backdropClassName = '' }) {
  useModalClose(onClose);
  return createPortal(
    <div className={`msg-modal-backdrop ${backdropClassName}`} onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className={`msg-new-modal ${className}`} role="dialog" aria-modal="true">{children}</section>
    </div>, document.body,
  );
}

function ModalHeader({ eyebrow, title, onClose }) {
  const t = useChatT();
  return (
    <header>
      <div><span>{eyebrow}</span><h2>{title}</h2></div>
      <button onClick={onClose} aria-label={t('Закрыть')}><Ic name="x" size={19} /></button>
    </header>
  );
}

function NewChatModal({ onClose, onOpen }) {
  const t = useChatT();
  const createDirect = useMessenger((state) => state.createDirect);
  const createGroup = useMessenger((state) => state.createGroup);
  const searchUsers = useMessenger((state) => state.searchUsers);
  const [mode, setMode] = useState('direct');
  const [query, setQuery] = useState('');
  const [title, setTitle] = useState('');
  const [picked, setPicked] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);
  useEffect(() => {
    let alive = true;
    const timer = window.setTimeout(() => searchUsers(query, false).then((items) => alive && setContacts(items)), 220);
    return () => { alive = false; window.clearTimeout(timer); };
  }, [query, searchUsers]);

  const chooseContact = async (contact) => {
    if (mode === 'group') {
      setPicked((current) => current.includes(contact.id)
        ? current.filter((id) => id !== contact.id) : [...current, contact.id]);
      return;
    }
    setBusy(true);
    const id = await createDirect(contact);
    setBusy(false);
    if (id) { onOpen(id); onClose(); }
  };
  const submitGroup = async () => {
    if (!title.trim() || !picked.length) return;
    setBusy(true);
    const id = await createGroup(title, picked);
    setBusy(false);
    if (id) { onOpen(id); onClose(); }
  };

  return (
    <Modal onClose={onClose}>
      <ModalHeader eyebrow={t('НОВОЕ ОБЩЕНИЕ')} title={t('Создать чат')} onClose={onClose} />
      <div className="msg-new-tabs">
        <button className={mode === 'direct' ? 'on' : ''} onClick={() => setMode('direct')}><Ic name="user" size={17} />{t('Личное сообщение')}</button>
        <button className={mode === 'group' ? 'on' : ''} onClick={() => setMode('group')}><Ic name="community" size={18} />{t('Группа')}</button>
      </div>
      {mode === 'group' && (
        <label className="msg-group-name"><span>{t('Название группы')}</span>
          <input value={title} onChange={(event) => setTitle(event.target.value)} maxLength={48} placeholder={t('Например, Команда на CS2 OPEN')} />
        </label>
      )}
      <label className="msg-contact-search"><Ic name="search" size={17} />
        <input ref={inputRef} value={query} onChange={(event) => setQuery(event.target.value)} placeholder={t('Найти человека по нику')} />
      </label>
      <div className="msg-contact-list">
        {contacts.map((contact) => {
          const checked = picked.includes(contact.id);
          return (
            <button type="button" key={contact.id} disabled={busy || contact.blocked} onClick={() => chooseContact(contact)}>
              <Avatar chat={contact} size={42} />
              <span><b>{contact.name}</b><small>{contact.handle || t('Участник платформы')}{contact.blocked ? ` · ${t('заблокирован')}` : ''}</small></span>
              {mode === 'group'
                ? <i className={`msg-check ${checked ? 'on' : ''}`}>{checked && <Ic name="check" size={13} sw={2.7} />}</i>
                : <Ic name="chevR" size={16} />}
            </button>
          );
        })}
        {!contacts.length && <div className="msg-inline-empty">{t('Пользователи не найдены')}</div>}
      </div>
      {mode === 'group' && (
        <footer><span>{t('Выбрано')}: <b>{picked.length}</b></span>
          <button disabled={busy || !title.trim() || !picked.length} onClick={submitGroup}>{t('Создать группу')}<Ic name="chevR" size={16} /></button>
        </footer>
      )}
    </Modal>
  );
}

function ReportModal({ chat, message, userId, onClose }) {
  const t = useChatT();
  const report = useMessenger((state) => state.report);
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    const ok = await report({ conversationId: chat.id, messageId: message?.id, userId, reason });
    setBusy(false);
    if (ok) onClose();
  };
  return (
    <Modal onClose={onClose} className="msg-report-modal">
      <ModalHeader eyebrow={t('БЕЗОПАСНОСТЬ')} title={t('Отправить жалобу')} onClose={onClose} />
      <label className="msg-group-name msg-report-reason"><span>{t('Причина')}</span>
        <textarea autoFocus value={reason} onChange={(event) => setReason(event.target.value)} maxLength={500} placeholder={t('Опишите нарушение')} />
      </label>
      <footer><span>{reason.length}/500</span><button disabled={busy || reason.trim().length < 5} onClick={submit}>{t('Отправить')}<Ic name="flag" size={16} /></button></footer>
    </Modal>
  );
}

function ForwardModal({ message, conversations, onClose }) {
  const t = useChatT();
  const sendMessage = useMessenger((state) => state.sendMessage);
  const fire = useAppStore((state) => state.fire);
  const [busy, setBusy] = useState(null);
  const [sent, setSent] = useState(null);
  const forward = async (chat) => {
    setBusy(chat.id);
    const result = await sendMessage(chat.id, '', [], { forward_message_id: message.id });
    setBusy(null);
    if (result) {
      setSent(chat.id);
      fire(`Сообщение переслано в «${chat.title}»`, 'success');
      window.setTimeout(onClose, 420);
    }
  };
  return (
    <Modal onClose={onClose} className="msg-forward-modal">
      <ModalHeader eyebrow={t('ПЕРЕСЫЛКА')} title={t('Выберите чат')} onClose={onClose} />
      <div className="msg-contact-list">
        {conversations.map((chat) => (
          <button type="button" key={chat.id} className={sent === chat.id ? 'msg-forward-sent' : ''} disabled={busy !== null || sent !== null} onClick={() => forward(chat)}>
            <Avatar chat={chat} size={42} /><span><b>{chat.title}</b><small>{t(chat.type === 'group' ? 'Группа' : 'Личный диалог')}</small></span>
            {busy === chat.id ? <i className="msg-mini-loader" /> : sent === chat.id ? <Ic name="check" size={18} sw={2.7} /> : <Ic name="forward" size={17} />}
          </button>
        ))}
      </div>
    </Modal>
  );
}

function ChatInfoModal({ chat, onClose, onLeave }) {
  const t = useChatT();
  const currentUser = useAppStore((state) => state.user);
  const updateConversation = useMessenger((state) => state.updateConversation);
  const updateConversationAvatar = useMessenger((state) => state.updateConversationAvatar);
  const addMembers = useMessenger((state) => state.addMembers);
  const changeRole = useMessenger((state) => state.changeRole);
  const removeMember = useMessenger((state) => state.removeMember);
  const blockUser = useMessenger((state) => state.blockUser);
  const searchUsers = useMessenger((state) => state.searchUsers);
  const [title, setTitle] = useState(chat.title);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [reporting, setReporting] = useState(false);
  const [avatarBusy, setAvatarBusy] = useState(false);
  const avatarInputRef = useRef(null);
  const canManage = chat.role === 'owner' || chat.role === 'admin';
  const other = chat.members.find((member) => member.id !== currentUser?.id);

  useEffect(() => {
    if (chat.type !== 'group' || !canManage || !query.trim()) { setResults([]); return undefined; }
    let alive = true;
    const timer = window.setTimeout(() => searchUsers(query, false).then((items) => {
      if (alive) setResults(items.filter((item) => !chat.memberIds.includes(item.id)));
    }), 220);
    return () => { alive = false; window.clearTimeout(timer); };
  }, [query, chat.type, chat.memberIds, canManage, searchUsers]);

  const saveTitle = async () => {
    if (title.trim() && title.trim() !== chat.title) await updateConversation(chat.id, { title: title.trim() });
  };
  const togglePreference = async (key, value) => {
    const updated = await updateConversation(chat.id, { [key]: value });
    if (updated) useAppStore.getState().fire(key === 'pinned' ? (value ? 'Чат закреплён' : 'Чат откреплён') : (value ? 'Уведомления отключены' : 'Уведомления включены'), 'success');
  };
  const changeAvatar = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 5 * 1024 * 1024) {
      useAppStore.getState().fire('Выберите JPEG, PNG или WebP до 5 МБ', 'error');
      return;
    }
    setAvatarBusy(true);
    await updateConversationAvatar(chat.id, file);
    setAvatarBusy(false);
  };
  const leave = async () => {
    if (!window.confirm('Покинуть эту группу?')) return;
    if (await removeMember(chat.id, currentUser.id)) { onLeave(); onClose(); }
  };

  if (reporting) return <ReportModal chat={chat} userId={other?.id} onClose={() => setReporting(false)} />;
  return (
    <Modal onClose={onClose} className="msg-info-modal" backdropClassName="msg-info-backdrop">
      <ModalHeader eyebrow={t(chat.type === 'group' ? 'УПРАВЛЕНИЕ ГРУППОЙ' : 'ЛИЧНЫЙ ДИАЛОГ')} title={chat.title} onClose={onClose} />
      <div className="msg-info-profile">
        <div className="msg-info-avatar"><Avatar chat={chat} size={74} />{chat.type === 'group' && canManage && <button type="button" disabled={avatarBusy} onClick={() => avatarInputRef.current?.click()} aria-label={t('Изменить аватар группы')}><Ic name="image" size={17} /></button>}</div>
        <div><b>{chat.title}</b><span>{chat.type === 'group' ? `${chat.members.length} · ${t(chat.role === 'owner' ? 'Вы владелец' : chat.role === 'admin' ? 'Вы администратор' : 'Вы участник')}` : other?.handle || t('Личный диалог')}</span></div>
        {chat.type === 'group' && canManage && <><input ref={avatarInputRef} hidden type="file" accept="image/jpeg,image/png,image/webp" onChange={changeAvatar} />{chat.avatar && <button className="msg-avatar-remove" type="button" disabled={avatarBusy} onClick={() => updateConversationAvatar(chat.id)}><Ic name="trash" size={15} />{t('Удалить фото')}</button>}</>}
      </div>
      <div className="msg-info-preferences">
        <button className={chat.pinned ? 'is-active' : ''} onClick={() => togglePreference('pinned', !chat.pinned)}><Ic name="pin" size={17} />{t(chat.pinned ? 'Открепить' : 'Закрепить')}</button>
        <button className={chat.muted ? 'is-active' : ''} onClick={() => togglePreference('muted', !chat.muted)}><Ic name="bell" size={17} />{t(chat.muted ? 'Включить push' : 'Отключить push')}</button>
      </div>
      {chat.type === 'direct' ? (
        <div className="msg-safety-actions">
          <button className="danger" disabled={chat.blocked && !chat.blockedByMe} onClick={() => blockUser(other.id, !chat.blockedByMe)}><Ic name="ban" size={17} />{t(chat.blockedByMe ? 'Разблокировать' : chat.blocked ? 'Сообщения недоступны' : 'Заблокировать')}</button>
          <button onClick={() => setReporting(true)}><Ic name="flag" size={17} />{t('Пожаловаться')}</button>
        </div>
      ) : (
        <>
          {canManage && (
            <div className="msg-info-title"><label><span>{t('Название группы')}</span><input value={title} maxLength={48} onChange={(event) => setTitle(event.target.value)} /></label>
              <button disabled={!title.trim() || title.trim() === chat.title} onClick={saveTitle}><Ic name="check" size={17} />{t('Сохранить')}</button>
            </div>
          )}
          <div className="msg-member-heading"><b>{t('Участники')}</b><span>{chat.members.length}</span></div>
          <div className="msg-member-list">
            {chat.members.map((member) => (
              <div key={member.id} className="msg-member-row">
                <Avatar chat={member} size={42} /><span><b>{member.name}</b><small>{member.handle || t('Участник платформы')}</small></span><i className={`msg-role-pill ${member.role}`}>{t(member.role === 'owner' ? 'Владелец' : member.role === 'admin' ? 'Админ' : 'Участник')}</i>
                {chat.role === 'owner' && member.id !== currentUser.id && (
                  <div className="msg-member-actions">
                    <button title={t(member.role === 'admin' ? 'Сделать участником' : 'Сделать администратором')} aria-label={t(member.role === 'admin' ? 'Сделать участником' : 'Сделать администратором')} onClick={() => changeRole(chat.id, member.id, member.role === 'admin' ? 'member' : 'admin')}><Ic name="crown" size={15} /></button>
                    <button title={t('Передать права владельца')} aria-label={t('Передать права владельца')} onClick={() => window.confirm(`Передать группу пользователю ${member.name}?`) && changeRole(chat.id, member.id, 'owner')}><Ic name="forward" size={15} /></button>
                    <button title={t('Исключить')} aria-label={t('Исключить участника')} onClick={() => window.confirm(`Исключить ${member.name}?`) && removeMember(chat.id, member.id)}><Ic name="x" size={15} /></button>
                  </div>
                )}
                {chat.role === 'admin' && member.role === 'member' && member.id !== currentUser.id && (
                  <button className="msg-member-remove" title={t('Исключить')} onClick={() => removeMember(chat.id, member.id)}><Ic name="x" size={15} /></button>
                )}
              </div>
            ))}
          </div>
          {canManage && (
            <div className="msg-add-member"><label className="msg-contact-search"><Ic name="search" size={16} /><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder={t('Добавить участника')} /></label>
              {!!results.length && <div className="msg-add-results">{results.map((user) => <button key={user.id} onClick={async () => { if (await addMembers(chat.id, [user.id])) setQuery(''); }}><span>{user.name}</span><Ic name="plus" size={15} /></button>)}</div>}
            </div>
          )}
          <button className="msg-leave-group" onClick={leave}><Ic name="logout" size={17} />{t('Покинуть группу')}</button>
        </>
      )}
    </Modal>
  );
}

function AttachmentPhoto({ attachment, onOpen }) {
  const [src, setSrc] = useState(attachment.localUrl || '');
  useEffect(() => {
    if (attachment.localUrl) return undefined;
    let alive = true;
    attachmentObjectUrl(attachment).then((url) => alive && setSrc(url)).catch(() => {});
    return () => { alive = false; };
  }, [attachment]);
  return src
    ? <button className="msg-photo" onClick={() => onOpen(src)}><img src={src} alt={attachment.name || 'Фотография'} /></button>
    : <div className="msg-photo msg-photo-loading"><i className="msg-mini-loader" /></div>;
}

function LocalPhotoPreview({ file, onRemove }) {
  const t = useChatT();
  const [src, setSrc] = useState('');
  useEffect(() => {
    const url = URL.createObjectURL(file);
    setSrc(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);
  return <div><img src={src} alt="" /><button onClick={onRemove} aria-label={t('Убрать фотографию')}><Ic name="x" size={13} /></button></div>;
}

function MessageBubble({ message, group, canModerate, onReply, onEdit, onForward, onReport, onPhoto }) {
  const t = useChatT();
  const deleteMessage = useMessenger((state) => state.deleteMessage);
  const toggleReaction = useMessenger((state) => state.toggleReaction);
  const [actions, setActions] = useState(false);
  const [reacting, setReacting] = useState(false);
  if (message.system) return <div className="msg-system"><i><Ic name="crown" size={20} /></i><span><b>{t('Системное сообщение')}</b><small>{message.text}</small></span><time>{time(message.at)}</time></div>;
  const canDelete = message.own || canModerate;
  const authorInitials = (message.author || '?').split(/\s+/).map((part) => part[0]).join('').slice(0, 2).toUpperCase();
  const authorAccent = ['#e11217', '#666b78', '#8d2530', '#343945'][Math.abs(Number(message.authorId) || String(message.authorId).length) % 4];
  return (
    <div className={`msg-message ${message.own ? 'own' : 'other'} ${message.pending ? 'pending' : ''} ${message.failed ? 'failed' : ''}`}>
      {!message.own && <Avatar chat={{ id: `author-${message.authorId}`, initials: authorInitials, accent: authorAccent }} size={44} />}
      <div className="msg-bubble" onClick={() => setActions((value) => !value)}>
        {group && !message.own && <b>{message.author}</b>}
        {message.forwardedFrom && <div className="msg-forwarded"><Ic name="forward" size={13} />{t('Переслано от')} {message.forwardedFrom.author}</div>}
        {message.replyTo && <div className="msg-reply-preview"><b>{message.replyTo.author}</b><span>{message.replyTo.text}</span></div>}
        {!!message.attachments?.length && <div className={`msg-photos count-${message.attachments.length}`}>{message.attachments.map((item) => <AttachmentPhoto key={item.id} attachment={item} onOpen={onPhoto} />)}</div>}
        {!!message.text && <p className={message.deleted ? 'deleted' : ''}>{message.text}</p>}
        {!message.deleted && !!message.reactions?.length && <div className="msg-reactions">{message.reactions.map((reaction) => <button key={reaction.emoji} className={reaction.own ? 'own' : ''} onClick={(event) => { event.stopPropagation(); toggleReaction(message.id, reaction.emoji); }}>{reaction.emoji}<b>{reaction.count}</b></button>)}</div>}
        <span><time>{time(message.at)}</time>{message.edited && <em>{t('изм.')}</em>}{message.pending && <i>…</i>}{message.failed && <em>{t('не отправлено')}</em>}{message.own && !message.pending && <i className={message.read ? 'read' : ''}>✓✓</i>}</span>
        {actions && !message.deleted && !message.pending && (
          <div className="msg-message-actions" onClick={(event) => event.stopPropagation()}>
            <button title={t('Ответить')} onClick={() => { onReply(message); setActions(false); }}><Ic name="reply" size={15} /></button>
            <button title={t('Реакция')} onClick={() => setReacting((value) => !value)}><Ic name="smile" size={15} /></button>
            <button title={t('Переслать')} onClick={() => onForward(message)}><Ic name="forward" size={15} /></button>
            {message.own && <button title={t('Редактировать')} onClick={() => onEdit(message)}><Ic name="edit" size={15} /></button>}
            {canDelete && <button title={t('Удалить')} onClick={() => window.confirm(t('Удалить сообщение?')) && deleteMessage(message.id)}><Ic name="trash" size={15} /></button>}
            {!message.own && <button title={t('Пожаловаться')} onClick={() => onReport(message)}><Ic name="flag" size={15} /></button>}
            {reacting && <div className="msg-reaction-picker">{REACTIONS.map((emoji) => <button key={emoji} onClick={() => { toggleReaction(message.id, emoji); setReacting(false); }}>{emoji}</button>)}</div>}
          </div>
        )}
      </div>
    </div>
  );
}

function ConversationList({ chats, contacts, selectedId, onSelect, query, setQuery, filter, setFilter, onNew, ready }) {
  const t = useChatT();
  const createDirect = useMessenger((state) => state.createDirect);
  const searchRef = useRef(null);
  useEffect(() => {
    const key = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault(); searchRef.current?.focus();
      }
    };
    window.addEventListener('keydown', key);
    return () => window.removeEventListener('keydown', key);
  }, []);
  const openPerson = async (contact) => { const id = await createDirect(contact); if (id) onSelect(id); };
  return (
    <aside className={`msg-sidebar ${selectedId ? 'mobile-hidden' : ''}`}>
      <header className="msg-sidebar-head"><div><span>{t('ВНУТРИ ПЛАТФОРМЫ')}</span><h1>{t('Сообщения')}</h1></div><button onClick={onNew} aria-label={t('Создать чат')}><Ic name="plus" size={20} sw={2.2} /></button></header>
      <label className="msg-search"><Ic name="search" size={17} /><input ref={searchRef} value={query} onChange={(event) => setQuery(event.target.value)} placeholder={t('Поиск по чатам')} /><kbd>⌘ K</kbd></label>
      <div className="msg-filters"><button onClick={() => setFilter('all')} className={filter === 'all' ? 'on' : ''}>{t('Все')}</button><button onClick={() => setFilter('unread')} className={filter === 'unread' ? 'on' : ''}>{t('Непрочитанные')}</button><button onClick={() => setFilter('groups')} className={filter === 'groups' ? 'on' : ''}>{t('Группы')}</button></div>
      <div className="msg-chat-list">
        {!!query.trim() && !!contacts.length && <div className="msg-people-results"><div className="msg-results-label"><span>{t('Пользователи')}</span><small>{t('по имени и username')}</small></div>{contacts.slice(0, 5).map((contact) => <button type="button" key={contact.id} onClick={() => openPerson(contact)}><Avatar chat={contact} size={42} /><span><b>{contact.name}</b><small>{contact.handle || t('Участник платформы')}</small></span><i><Ic name="chat" size={16} /></i></button>)}</div>}
        {!!query.trim() && !!chats.length && <div className="msg-results-label msg-chat-results-label"><span>{t('Чаты')}</span><small>{chats.length}</small></div>}
        {chats.map((chat) => {
          const last = chat.messages?.at(-1) || chat.lastMessage;
          return <button key={chat.id} className={`${selectedId === chat.id ? 'active' : ''} ${chat.pinned ? 'pinned' : ''}`} onClick={() => onSelect(chat.id)}><Avatar chat={chat} />{chat.pinned && <i className="msg-pinned-mark" title={t('Закреплённый чат')}><Ic name="pin" size={11} /></i>}<span className="msg-chat-copy"><span><b>{chat.title}</b><time>{last ? time(last.at) : ''}</time></span><small>{last?.own ? `${t('Вы')}: ` : ''}{last?.deleted ? t('Сообщение удалено') : last?.text || (last?.attachments?.length ? t('Фотография') : t('Начните новый диалог'))}</small></span>{chat.unread > 0 && <i className="msg-unread">{chat.unread}</i>}</button>;
        })}
        {!chats.length && ready && <div className="msg-empty-list"><Ic name="search" size={28} /><b>{t(query ? 'Ничего не найдено' : 'Диалогов пока нет')}</b><span>{t(query ? 'Проверьте имя или username пользователя' : 'Создайте личный чат или группу')}</span></div>}
        {!ready && <div className="msg-page-loader"><i className="msg-mini-loader" />{t('Загрузка диалогов')}</div>}
      </div>
    </aside>
  );
}

function ChatView({ chat, conversations, onBack }) {
  const t = useChatT();
  const kz = useFedStore((state) => state.lang === 'kz');
  const startChatPolling = useMessenger((state) => state.startChatPolling);
  const markRead = useMessenger((state) => state.markRead);
  const loadOlder = useMessenger((state) => state.loadOlder);
  const sendMessage = useMessenger((state) => state.sendMessage);
  const editMessage = useMessenger((state) => state.editMessage);
  const fire = useAppStore((state) => state.fire);
  const [text, setText] = useState('');
  const [files, setFiles] = useState([]);
  const [reply, setReply] = useState(null);
  const [editing, setEditing] = useState(null);
  const [infoOpen, setInfoOpen] = useState(false);
  const [forwarding, setForwarding] = useState(null);
  const [reporting, setReporting] = useState(null);
  const [lightbox, setLightbox] = useState('');
  const scrollRef = useRef(null), textareaRef = useRef(null), fileRef = useRef(null), nearBottomRef = useRef(true), previousChatRef = useRef(null);
  const chatId = chat?.id, messageCount = chat?.messages?.length;

  useEffect(() => {
    startChatPolling(chatId || null);
    return () => startChatPolling(null);
  }, [chatId, startChatPolling]);
  useLayoutEffect(() => {
    if (!chatId) return;
    if (previousChatRef.current !== chatId) nearBottomRef.current = true;
    previousChatRef.current = chatId;
    if (nearBottomRef.current && scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [chatId, messageCount]);
  useEffect(() => { if (chatId) markRead(chatId); }, [chatId, markRead]);
  useEffect(() => {
    const field = textareaRef.current;
    if (!field) return;
    field.style.height = '44px';
    field.style.height = `${Math.min(field.scrollHeight, 110)}px`;
  }, [text]);

  if (!chat) return <section className="msg-no-chat"><div className="msg-no-chat-art"><Ic name="chat" size={42} /><i /><i /></div><h2>{t('Выберите диалог')}</h2><p>{t('Продолжите общение с игроками или создайте новую группу.')}</p></section>;

  const pickFiles = (event) => {
    const picked = [...event.target.files];
    const allowed = picked.filter((file) => ['image/jpeg', 'image/png', 'image/webp'].includes(file.type) && file.size <= 5 * 1024 * 1024);
    if (allowed.length !== picked.length) fire('Разрешены JPEG, PNG и WebP до 5 МБ', 'error');
    setFiles((current) => [...current, ...allowed].slice(0, 4));
    event.target.value = '';
  };
  const beginEdit = (message) => { setEditing(message); setReply(null); setFiles([]); setText(message.text); textareaRef.current?.focus(); };
  const submit = async () => {
    if (editing) {
      if (!text.trim()) return;
      if (await editMessage(editing.id, text.trim())) { setEditing(null); setText(''); }
      return;
    }
    if (!text.trim() && !files.length) return;
    const sent = await sendMessage(chat.id, text, files, { reply_to_id: reply?.id, reply });
    if (sent) { setText(''); setFiles([]); setReply(null); textareaRef.current?.focus(); }
  };
  const cancelContext = () => { setReply(null); setEditing(null); setText(''); };
  const canModerate = chat.type === 'group' && ['owner', 'admin'].includes(chat.role);
  let previousDay = '';

  return (
    <section className="msg-chat-view">
      <header className="msg-chat-header msg-chat-header-open" role="button" tabIndex={0} onClick={() => setInfoOpen(true)} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); setInfoOpen(true); } }} aria-label={t('Открыть информацию и управление чатом')}><button className="msg-back" onClick={(event) => { event.stopPropagation(); onBack(); }} aria-label={t('Назад к диалогам')}><Ic name="chevR" size={20} style={{ transform: 'rotate(180deg)' }} /></button><Avatar chat={chat} size={42} /><div><h2>{chat.title}</h2><p>{chat.type === 'group' ? `${chat.members.length} ${t('участника')}` : t(chat.blocked ? 'обмен сообщениями заблокирован' : 'личный диалог')}</p></div><button className="msg-header-action" onClick={(event) => { event.stopPropagation(); setInfoOpen(true); }} aria-label={t('Участники и управление чатом')}><Ic name={chat.type === 'group' ? 'community' : 'user'} size={18} /></button></header>
      <div className="msg-thread" ref={scrollRef} onScroll={(event) => { const node = event.currentTarget; nearBottomRef.current = node.scrollHeight - node.scrollTop - node.clientHeight < 120; }}>
        {chat.hasMore !== false && chat.messages?.length >= 50 && <button className="msg-load-older" onClick={() => loadOlder(chat.id)}>{t('Загрузить предыдущие сообщения')}</button>}
        {(chat.messages || []).map((message) => {
          const label = day(message.at, kz), showDay = label !== previousDay; previousDay = label;
          return <div key={message.id}>{showDay && <div className="msg-day"><span>{label}</span></div>}<MessageBubble message={message} group={chat.type === 'group'} canModerate={canModerate} onReply={(item) => { setReply(item); setEditing(null); textareaRef.current?.focus(); }} onEdit={beginEdit} onForward={setForwarding} onReport={setReporting} onPhoto={setLightbox} /></div>;
        })}
      </div>
      {(reply || editing) && <div key={editing?.id || reply?.id} className="msg-compose-context"><Ic name={editing ? 'edit' : 'reply'} size={16} /><span><b>{editing ? t('Редактирование') : `${t('Ответ')}: ${reply.author}`}</b><small>{editing ? editing.text : reply.text || t('Фотография')}</small></span><button onClick={cancelContext}><Ic name="x" size={16} /></button></div>}
      {!!files.length && <div className="msg-file-preview">{files.map((file, index) => <LocalPhotoPreview key={`${file.name}-${file.lastModified}-${index}`} file={file} onRemove={() => setFiles((items) => items.filter((_, itemIndex) => itemIndex !== index))} />)}</div>}
      <footer className="msg-composer"><input ref={fileRef} hidden type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={pickFiles} /><button type="button" onClick={() => fileRef.current?.click()} disabled={editing || chat.blocked} aria-label={t('Прикрепить фотографии')}><Ic name="clip" size={21} /></button><textarea ref={textareaRef} rows={1} value={text} disabled={chat.blocked} onChange={(event) => setText(event.target.value)} onFocus={() => { nearBottomRef.current = true; window.setTimeout(() => scrollRef.current?.scrollTo({ top: scrollRef.current.scrollHeight }), 80); }} onKeyDown={(event) => { if (event.key === 'Enter' && !event.shiftKey) { event.preventDefault(); submit(); } }} enterKeyHint="send" autoComplete="off" aria-label={t('Сообщение')} placeholder={t(chat.blocked ? 'Разблокируйте пользователя для отправки' : 'Написать сообщение…')} /><button type="button" className="msg-send" onClick={submit} disabled={chat.blocked || (!text.trim() && !files.length)} aria-label={t('Отправить сообщение')}><Ic name={editing ? 'check' : 'send'} size={19} sw={2} /></button></footer>
      {infoOpen && <ChatInfoModal chat={chat} onClose={() => setInfoOpen(false)} onLeave={onBack} />}
      {forwarding && <ForwardModal message={forwarding} conversations={conversations} onClose={() => setForwarding(null)} />}
      {reporting && <ReportModal chat={chat} message={reporting} userId={reporting.authorId} onClose={() => setReporting(null)} />}
      {lightbox && createPortal(<div className="msg-lightbox" onClick={() => setLightbox('')}><button aria-label={t('Закрыть')}><Ic name="x" size={22} /></button><img src={lightbox} alt={t('Фотография из сообщения')} /></div>, document.body)}
    </section>
  );
}

export default function FedMessenger() {
  const t = useChatT();
  const user = useAppStore((state) => state.user);
  const conversations = useMessenger((state) => state.conversations);
  const contacts = useMessenger((state) => state.contacts);
  const ready = useMessenger((state) => state.ready);
  const searchUsers = useMessenger((state) => state.searchUsers);
  const deepLinkedId = useFedStore((state) => state.messengerId);
  const { go } = useFedStore();
  const [selectedId, setSelectedId] = useState(() => deepLinkedId || null);
  const [query, setQuery] = useState('');
  const [filter, setFilter] = useState('all');
  const [newOpen, setNewOpen] = useState(false);
  const pageRef = useRef(null);

  useEffect(() => {
    if (deepLinkedId) setSelectedId(deepLinkedId);
    else if (!selectedId && window.matchMedia?.('(min-width: 901px)').matches && conversations[0]) setSelectedId(conversations[0].id);
  }, [deepLinkedId, conversations, selectedId]);
  useEffect(() => {
    if (!query.trim()) return undefined;
    const timer = window.setTimeout(() => searchUsers(query), 220);
    return () => window.clearTimeout(timer);
  }, [query, searchUsers]);

  const selectChat = (id) => { setSelectedId(id); useFedStore.setState({ messengerId: id }); };
  const back = () => { setSelectedId(null); useFedStore.setState({ messengerId: null }); };
  const chats = useMemo(() => conversations.filter((chat) => {
    const last = chat.messages?.at(-1) || chat.lastMessage;
    const matches = `${chat.title} ${last?.text || ''}`.toLowerCase().includes(query.toLowerCase());
    return matches && (filter === 'all' || (filter === 'unread' && chat.unread > 0) || (filter === 'groups' && chat.type === 'group'));
  }), [conversations, query, filter]);
  const selected = conversations.find((chat) => chat.id === selectedId);

  useEffect(() => {
    const mobile = window.matchMedia?.('(max-width: 700px)').matches;
    const page = pageRef.current;
    if (!selectedId || !mobile || !page) return undefined;
    const viewport = window.visualViewport;
    const root = document.documentElement;
    const body = document.body;
    const updateViewport = () => {
      const top = viewport?.offsetTop || 0;
      const height = viewport?.height || window.innerHeight;
      page.style.setProperty('--msg-visual-top', `${Math.round(top)}px`);
      page.style.setProperty('--msg-visual-height', `${Math.round(height)}px`);
      page.classList.toggle('keyboard-open', Boolean(viewport && window.innerHeight - viewport.height > 140));
    };
    root.classList.add('msg-screen-lock');
    body.classList.add('msg-screen-lock');
    updateViewport();
    viewport?.addEventListener('resize', updateViewport);
    viewport?.addEventListener('scroll', updateViewport);
    window.addEventListener('resize', updateViewport);
    return () => {
      viewport?.removeEventListener('resize', updateViewport);
      viewport?.removeEventListener('scroll', updateViewport);
      window.removeEventListener('resize', updateViewport);
      root.classList.remove('msg-screen-lock');
      body.classList.remove('msg-screen-lock');
    };
  }, [selectedId]);

  if (!user) return <div className="msg-auth-gate"><div><Ic name="chat" size={40} /></div><span>{t('ОБЩЕНИЕ ВНУТРИ ПЛАТФОРМЫ')}</span><h1>{t('Войдите, чтобы открыть сообщения')}</h1><p>{t('Личные диалоги и командные группы доступны участникам платформы.')}</p><button onClick={() => go('auth', { authMode: 'login' })}>{t('Войти в аккаунт')}<Ic name="chevR" size={17} /></button></div>;
  return <div ref={pageRef} className={`msg-page ${selectedId ? 'msg-dialog-open' : ''}`}><div className="msg-shell"><ConversationList chats={chats} contacts={contacts} selectedId={selectedId} onSelect={selectChat} query={query} setQuery={setQuery} filter={filter} setFilter={setFilter} onNew={() => setNewOpen(true)} ready={ready} /><ChatView chat={selected} conversations={conversations} onBack={back} /></div>{newOpen && <NewChatModal onClose={() => setNewOpen(false)} onOpen={selectChat} />}</div>;
}
